import styled from 'styled-components'

import { RadioButton } from '@sketch/components'

export const StyledRadioButton = styled(RadioButton)`
  :not(:last-child) {
    margin-bottom: 8px;
  }
`
